import { RequestHeaders, APIFetchV2, APIFetchV3 } from "@certa/network";
import {
  kindsModelCreator,
  kindsHeirarchyModelCreator,
  type KindsHeirarchyResponse,
  workflowKindsDynamicAPIModelCreator,
  workflowKindsDynamicAPIUnlimitedModelCreator,
  type WorkflowKindsDynamicAPIResponse,
  type WorkflowKindsDynamicAPIUnlimitedResponse,
  workflowKindsPaginatedAPIModelCreator
} from "../models/kinds.models";

export type GetAllKindsArgs = {
  hideInternal?: boolean;
  allowThirdParty?: boolean;
  useV3?: boolean;
};

export function getAllKinds(params: GetAllKindsArgs = {}) {
  const requestOptions: RequestInit = {
    method: "GET",
    headers: RequestHeaders.GET,
    credentials: "include"
  };

  const searchParams = new URLSearchParams({
    limit: "200",
    ...(params.hideInternal ? { hide_internal: "True" } : undefined),
    ...(params.allowThirdParty
      ? { allowed_for_third_party: "True" }
      : undefined)
  });

  const APIFetch = params.useV3 ? APIFetchV3 : APIFetchV2;

  // Essentially this API shouldn't have limit param because we always need
  // all the workflow kinds that are available within the system.
  return APIFetch<any[]>(
    `workflow-kinds/?${searchParams}`,
    requestOptions
  ).then(kindsModelCreator);
}

export const workflowKindsHeirarchy = () => {
  const requestOptions: RequestInit = {
    method: "GET",
    headers: RequestHeaders.GET,
    credentials: "include"
  };
  return APIFetchV3<KindsHeirarchyResponse>(
    "workflow-kind-hierarchy/",
    requestOptions
  ).then(kindsHeirarchyModelCreator);
};

export const getWorkflowKindsDynamicAPI = (payload: any) => {
  const requestOptions: RequestInit = {
    method: "POST",
    headers: RequestHeaders.POST,
    credentials: "include",
    body: JSON.stringify(payload)
  };

  return APIFetchV3<WorkflowKindsDynamicAPIResponse>(
    `workflow-kind-list-drest/`,
    requestOptions
  ).then(workflowKindsDynamicAPIModelCreator);
};

export const getWorkflowKindsDynamicAPIUnlimited = (payload: any) => {
  const requestOptions: RequestInit = {
    method: "POST",
    headers: RequestHeaders.POST,
    credentials: "include",
    body: JSON.stringify(payload)
  };

  return APIFetchV3<WorkflowKindsDynamicAPIUnlimitedResponse>(
    `workflow-kind-list-drest/?limit=none`,
    requestOptions
  ).then(workflowKindsDynamicAPIUnlimitedModelCreator);
};

export type GetPaginatedWorkflowKindsDynamicAPIParams = {
  payload: any;
  offset: number;
  limit?: number;
};

export const getPaginatedWorkflowKindsDynamicAPI = async ({
  payload,
  offset,
  limit = 20
}: GetPaginatedWorkflowKindsDynamicAPIParams) => {
  const requestOptions: RequestInit = {
    method: "POST",
    headers: RequestHeaders.POST,
    credentials: "include",
    body: JSON.stringify(payload)
  };

  const response = await APIFetchV3<WorkflowKindsDynamicAPIResponse>(
    `workflow-kind-list-drest/?limit=${limit}&offset=${offset}`,
    requestOptions
  );

  return workflowKindsPaginatedAPIModelCreator(response);
};
